import FormInput from "../../components/common/FormInput/FormInput";
import UploadImage from "../../components/common/UploadImage/UplaodImage";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormDatePicker from "../../components/common/FormDatePicker/FormDatePicker";
import BlogListing from "./BlogListing/BlogListing";

const Blog = () => {
  return (
    <>
      <BlogListing />
    </>
  );
};

export default Blog;
